/* eslint-disable */
import {
  FormLabel,
  FormControl,
  Tooltip,
  Stack,
  useRadio,
  Box,
  useRadioGroup,
  HStack,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { QuestionIcon } from "@chakra-ui/icons";
import React, { useState } from "react";

interface B4FRadioProps {
  options: any;
  label?: string;
  id?: string;
  onChange: any;
  value: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
  visible: boolean;
  images?: any;
  onUpdate?: any;
  defaultValue?: any;
}

function RadioCard(props: any) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input: any = getInputProps();
  const checkbox = getCheckboxProps();
  const required = input["required"];

  return (
    <Box style={{ marginBottom: 0 }} as="label">
      <input autoComplete="nope" {...input} />
      <Box
        cursor="pointer"
        borderWidth="1px"
        color="#636E95"
        borderRadius="md"
        boxShadow="md"
        borderColor="brand.grey"
        _hover={{
          transition: "0.3s",
          borderColor: "brand.white",
        }}
        _checked={{
          bg: "brand.bf3",
          color: "white",
          borderColor: "brand.bf3",
        }}
        _disabled={{
          color: "brand.grey",
          borderColor: "brand.white",
        }}
        style={
          required && (props.radioVal === null || props.radioVal === "")
            ? { border: "1px solid #ae0064" }
            : undefined
        }
        px={3}
        py={2}
        mr={2}
        {...checkbox}
      >
        {props.children}
      </Box>
    </Box>
  );
}

export const B4FRadio: React.FC<B4FRadioProps> = (props: any) => {
  const [value, setValue] = useState(props.value);
  const [options, setOptions] = useState(props.options);
  const { t, i18n } = useTranslation();
  React.useEffect(() => {
    // Replace key -> value
    if (props.options.length > 0) {
      props.options.forEach((option: any) => {
        setOptions((oldOptions: any) => [
          ...oldOptions,
          { key: option.label, value: option.value },
        ]);
      });
    }
  }, [props.options]);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  function isValid(value: string): boolean {
    if (props.isRequired && value !== "") {
      return true;
    } else {
      return false;
    }
  }

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: props.id,
    defaultValue: "",
    onChange: handleChange,
  });

  const group = getRootProps();

  function handleChange(e: any) {
    if (e !== "") {
      setValue(e);
    }
    props.onChange({
      target: {
        id: props.id,
        value: e,
      },
      id: props.id,
      type: "radio",
      value: e,
      valid: isValid(e),
      required: props.isRequired,
    });
  }

  const optionsArray = [];
  let labelLength = 0;
  if (props.options) {
    for (let j = 0; j < props.options.length; j++) {
      const radio: any = getRadioProps(options[j]);

      if (value === props.options[j].key) {
        radio["isChecked"] = true;
      }
      labelLength += props.options[j].label.length;

      let label: JSX.Element | string = props.options[j].label;

      if (
        [
          "YES",
          "NO",
          "LISTED",
          "REGULATED",
          "LISTED_REGULATED",
          "NONE",
        ].includes(props.options[j].label.toUpperCase())
      ) {
        label = t(props.options[j].label.toUpperCase());
      } else {
        label = props.options[j].label;
      }

      optionsArray.push(
        <RadioCard
          {...radio}
          key={options[j].label}
          value={options[j].key}
          ml={2}
          isDisabled={props.isDisabled}
          isRequired={props.isRequired}
          radioVal={props.value}
          defaultValue={props.defaultValue}
        >
          {t(`ENUMS.${label}`)}
        </RadioCard>
      );
    }
  }

  if (props.visible) {
    return (
      <FormControl
        isRequired={props.isRequired}
        isDisabled={props.isDisabled}
        id={props.id}
      >
        {labelLength < 30 ? (
          <Stack direction="row" {...group} mb={5}>
            <FormLabel>{t(props.label)}</FormLabel>
            {props.tooltip && props.tooltip !== "" ? (
              <Tooltip
                label={props.tooltip}
                fontSize="md"
                bg="brand.white"
                color="brand.text"
              >
                {props.isDisabled ? (
                  <QuestionIcon color="brand.grey" />
                ) : (
                  <QuestionIcon color="brand.bf2" />
                )}
              </Tooltip>
            ) : null}
            <HStack value={value}>{optionsArray}</HStack>
          </Stack>
        ) : (
          <Stack direction="column" {...group} mb={5}>
            <FormLabel>{t(props.label)}</FormLabel>
            {props.tooltip ? (
              <Tooltip
                label={props.tooltip}
                fontSize="md"
                bg="brand.white"
                color="brand.text"
              >
                <QuestionIcon color="brand.bf2" />
              </Tooltip>
            ) : null}
            <Flex>
              <Box d="flex" flexWrap="wrap">
                {optionsArray}
              </Box>
            </Flex>
          </Stack>
        )}
      </FormControl>
    );
  } else {
    return null;
  }
};
